import ApiService from '../../../../../../services/ApiService'

export default {
  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.values = [this.institutionId]
    this.getInstitutions()
    this.getDepartments()
    this.getStandardEquipment()
    await this.getUnidades()

    if (this.institution.userType == 5) {
      this.unidadeSelected = this.unidades.filter(
        (x) => x.id === this.userLogged.unidadeId
      )
    }

    const currentYear = new Date().getFullYear()
    this.years.unshift(currentYear)

    for (let i = 0; i < 3; i++) {
      const year = currentYear - i
      this.years.unshift(year)
    }

    for (let i = 0; i < 3; i++) {
      const year = currentYear + i
      this.years.push(year)
    }

    this.year = currentYear

    this.format = this.formats[0]
  },

  data: () => ({
    correctiveMaintenanceEquipment: false,
    departmentSearch: '',
    unitySearch: '',
    institution: {},
    typeSearch: '',
    identification: '',
    propertyCode: '',
    searchInput: '',
    values: [],
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    departmentLoading: false,
    standardEquipmentLoading: false,
    menu: false,
    date: null,
    month: null,
    year: null,
    format: null,
    responsibility: null,
    institutionId: null,
    search: null,
    institutions: [],
    selectedInstitutions: [],
    unidadeSelected: [],
    unidades: [],
    standardEquipmentSelected: [],
    standardEquipment: [],
    departmentSelected: [],
    departments: [],
    serviceOrderTypeSelected: [],
    userLogged: {},
    apiService: new ApiService(),
    serviceOrderTypes: [
      {
        name: 'Treinamento',
        value: 0,
      },
      {
        name: 'Segurança elétrica',
        value: 1,
      },
      {
        name: 'Preventiva',
        value: 2,
      },
      {
        name: 'Calibração',
        value: 6,
      },
      {
        name: 'Validação/Qualificação',
        value: 7,
      },
    ],
    responsibilities: ['Interna', 'Externa'],
    months: [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ],
    years: [],
    formats: ['HTML', 'Excel', 'PDF'],
    state: null,
    states: [
      { text: 'Agendada', value: 0 },
      { text: 'Executada dentro do prazo', value: 1 },
      { text: 'Executada fora do prazo', value: 2 },
      { text: 'Atrasada', value: 3 },
    ],
  }),

  components: {},

  computed: {
    icon() {
      if (this.likesAllInstitution) return 'mdi-close-box'
      if (this.likesSomeInstitution) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    likesSomeInstitution() {
      return this.values.length > 0 && !this.likesAllInstitution
    },
    likesAllInstitution() {
      return this.values.length === this.institutions.length
    },
    subDepartments() {
      const departments = this.localDepartments.filter(
        (x) =>
          this.filter.equipmentDepartmentIds &&
          this.filter.equipmentDepartmentIds.includes(x.id)
      )

      return departments.map((x) => x.subDepartments).flat(1)
    },
  },
  
  methods: {
    removeUnidade(item) {
      this.unidadeSelected.splice(this.unidadeSelected.indexOf(item), 1)
      this.unidadeSelected = [...this.unidadeSelected]
    },
    removeInstitution(item) {
      this.values.splice(this.values.indexOf(item), 1)
      this.values = [...this.values]
    },

    removeStandardEquipment(item) {
      this.standardEquipmentSelected.splice(
        this.standardEquipmentSelected.indexOf(item),
        1
      )
      this.standardEquipmentSelected = [...this.standardEquipmentSelected]
    },

    removeServiceOrderType(item) {
      this.serviceOrderTypeSelected.splice(
        this.serviceOrderTypeSelected.indexOf(item),
        1
      )
      this.serviceOrderTypeSelected = [...this.serviceOrderTypeSelected]
    },

    removeDepartment(item) {
      this.departmentSelected.splice(this.departmentSelected.indexOf(item), 1)
      this.departmentSelected = [...this.departmentSelected]
    },

    removeStatus(item) {
      this.state.splice(this.state.indexOf(item), 1)
      this.state = [...this.state]
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService
        .get('institution/listuser')
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch(() => {
          this.institutionLoading = false
        })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .post(`bigdata/unidade`, this.values)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
        .catch(() => {
          this.unidadeLoading = false
        })
    },

    async getStandardEquipment() {
      this.standardEquipmentLoading = true

      await this.apiService
        .get(`standardEquipment/list`)
        .then((response) => {
          this.standardEquipment = response.content
          this.standardEquipmentLoading = false
        })
        .catch(() => {
          this.standardEquipmentLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .post(`bigdata/department`, this.values)
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
        .catch(() => {
          this.departmentLoading = false
        })
    },

    async scheduleExport() {
      this.loading = true

      const types = this.serviceOrderTypeSelected

      const filter = {
        idEquipment: this.identification,
        propertyCode: this.propertyCode,
        institutionIds: this.values,
        InstitutionId: this.institutionId,
        Unidades: this.unidadeSelected,
        StandardEquipmentIds: this.standardEquipmentSelected,
        ServiceOrderTypes: types,
        Departments: this.departmentSelected,
        Month: this.months.indexOf(this.month) + 1,
        Year: this.year,
        ExportType: this.format == 'HTML' ? 'Front' : this.format,
        Responsibility:
          this.responsibility != null
            ? this.responsibilities.indexOf(this.responsibility)
            : null,
        BaseUrl: 'https://app.fixsystem.io',
        isBigData: true,
        ChronogramStatus: this.correctiveMaintenanceEquipment
          ? this.state
            ? [...this.state, 4]
            : [4]
          : this.state,
      }

      await this.apiService
        .post('bigdata/scheduleExport', filter)
        .then((response) => {
          localStorage.removeItem('scheduleFilters')
          localStorage.setItem('scheduleFilters', JSON.stringify(filter))
          window.open('/schedule', '_blank')

          if (this.format == 'PDF') {
            var pdfResult =
              'data:application/pdf;base64,' + response.content.pdf
            const link = document.createElement('a')
            link.href = pdfResult
            link.setAttribute('download', `Cronograma ${this.year}`)
            document.body.appendChild(link)
            link.click()
          }

          if (this.format == 'Excel') {
            var excelResult = `data:application/octet-stream;base64,${response.content.excel}`
            const link = document.createElement('a')
            link.href = excelResult
            link.setAttribute('download', `Cronograma ${this.year}.xlsx`)
            document.body.appendChild(link)
            link.click()
          }
        })
        .catch((err) => {})

      this.loading = false
    },

    reset() {
      if (this.institution.userType == 5) {
        this.unidadeSelected = this.unidades.filter(
          (x) => x.id === this.userLogged.unidadeId
        )
      } else {
        this.unidadeSelected = []
      }

      this.standardEquipmentSelected = []
      this.serviceOrderTypeSelected = []
      this.departmentSelected = []
      this.month = null
      this.year = new Date().getFullYear()
      this.format = this.formats[0]
      this.responsibility = null
      this.values = []
      this.state = null
    },

    toggle() {
      this.$nextTick(() => {
        if (this.likesAllInstitution) {
          this.values = []
        } else {
          this.values = this.institutions.map((x) => x.id).slice()
        }
      })
    },
  },

  watch: {
    standardEquipmentSelected() {
      this.search = ''
    },
    values(nv, ov) {
      if (nv) {
        this.getUnidades()
        this.getDepartments()
        this.getStandardEquipment()
      }
    },
  },
}
